// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "staticbackend/js/" + chunkId + "." + "453f2ef2" + ".chunk.js";
};